var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildrenEmptyStateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "390px",
    height: "128px",
    viewBox: "0 0 390 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "school illustration 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.584668698,2.11639632 C0.565868698,1.83280359 0.552668698,1.62236957 0.538668698,1.41193555 L0.538668698,1.41193555 C0.196668698,2.28846997 0.461868698,3.20363875 0.164268698,4.0831872 L0.164268698,4.0831872 C0.115468698,4.22868259 0.110268698,4.38075405 0.0706686975,4.52761946 L0.0706686975,4.52761946 C0.0286686975,4.68106093 -0.0785313025,4.84053046 0.250268698,5 L0.250268698,5 C0.546668698,3.58806445 0.874268698,2.23805348 1.8658687,1.01654976 L1.8658687,1.01654976 C1.3982687,0.694322665 2.2830687,0.421416045 1.8634687,0 L1.8634687,0 C1.4246687,0.726654975 1.0262687,1.3856313 0.584668698,2.11639632 L0.584668698,2.11639632 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1501958,1.35850687 C16.0963107,2.22103172 14.7537154,3.01006654 9.40289455,3.32247473 L9.40289455,3.32247473 C6.47564562,3.49334659 5.05861263,3.36390737 3.33106034,3.67964228 L3.33106034,3.67964228 C0,4.28842997 -0.242764227,5.77788818 0.131054291,7 L0.131054291,7 L95,7 C92.7242168,6.27387021 84.9625925,4.15112763 63.5291536,3.44556294 L63.5291536,3.44556294 C58.1957196,3.27015467 57.1394649,2.22224142 51.4036871,1.23511622 L51.4036871,1.23511622 C49.7785544,0.955067831 45.4003138,0.217748207 39.7789092,0.0408277888 L39.7789092,0.0408277888 C38.8962518,0.0130044068 38.0252765,0 37.1706013,0 L37.1706013,0 C29.1150295,0 22.4936061,1.12956882 21.1501958,1.35850687 L21.1501958,1.35850687 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auth,-Account-+-Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Family-Account-(p)---parent-manage-Copy",
    transform: "translate(-525.000000, -732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "school-illustration-2",
    transform: "translate(525.000000, 732.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.570412,69.0093074 C261.38379,68.4691313 244.277945,91.6124168 183.235541,93.9570104 C155.818859,95.0067143 145.237575,89.0647782 113.674021,91.5626133 C83.5753947,93.9455174 62.2323344,101.672587 48,108.242813 L373,110 C343.949359,70.7778586 317.614471,69.296635 298.570412,69.0093074 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    transform: "translate(210.500000, 89.500000) scale(-1, 1) translate(-210.500000, -89.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "tree",
    transform: "translate(274.000000, 69.500000) scale(-1, 1) translate(-274.000000, -69.500000) translate(264.000000, 47.000000)",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.075215,33.3883573 C14.9029191,34.4645929 13.5415776,35.1007777 13.5415776,35.1007777 C12.9518402,35.3735871 11.7537534,35.8630881 10.1557724,35.9764347 C9.51817536,36.0217176 8.2889797,36.0447759 6.81649743,35.6244495 C5.38895006,35.2171801 4.40782699,34.585996 4.08743314,34.3701376 C2.99676462,33.6367194 2.25945994,32.8096791 1.80878145,32.2201664 C1.11641167,31.0586431 0.433082045,29.8915634 0.13901101,28.5347397 C-0.216214039,26.895661 0.185009463,25.5513386 0.498490251,24.3364758 C1.43069012,20.7230017 2.94890495,20.1748827 2.63781715,18.2763296 C2.36767594,16.6278054 1.18368108,16.6775334 0.884026419,14.8592673 C0.568950308,12.9468236 1.46286244,10.8935303 2.93268585,10.1228855 C3.7954892,9.67061093 4.71412882,9.7478421 5.63090725,9.89897071 C6.059783,9.96953443 6.48201157,10.0962158 6.92045926,10.0909374 C7.35651395,10.0851034 7.50647423,9.8706341 7.42670813,9.41724827 C7.36582,9.07248613 7.26398528,8.74550381 7.12120395,8.42824486 C6.624527,7.32561718 6.36156476,6.17020561 6.43149305,4.94450813 C6.5593847,2.7086937 8.02069971,0.632619977 10.0757404,0.10978166 C11.1618889,-0.166361426 12.1685371,0.113393189 13.1507237,0.560389392 C13.571357,0.751800445 15.0789363,1.44771436 15.7867276,3.0245636 C16.4123597,4.41805829 15.7157357,4.94839748 16.0627183,7.14837444 C16.3522692,8.9855316 16.9050483,9.0410936 17.4806937,11.2230129 C17.9983758,13.1854624 17.6668146,13.8313705 18.0124677,15.8529935 C18.5660446,19.0933687 19.3434981,19.355899 19.7851364,21.5944916 C20.7032444,26.2489195 18.5312134,31.1333739 16.075215,33.3883573",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10624424,4 C5.29923055,6.61814286 5.50706196,7.13468706 5.76469627,9.78741495 C5.93733041,11.5632449 6.12504911,13.4977755 6.07692224,15.9273741 C6.00078124,19.7679863 5.43547025,19.7677075 5.664851,22.0360953 C5.97540091,25.1085849 7.00067057,25.2053672 7.26117813,28.3581837 C7.41465732,30.2154558 7.16588217,31.7240883 6.86203648,33.5646257 C6.52802174,35.5892449 6.20047178,36.3648978 5.74458355,38.3061223 C5.37656873,39.8733264 4.94103265,42.1344625 4.71428572,45 L6.29935931,44.4126122 C6.85700831,40.483306 7.4946293,37.4161156 7.97948942,35.3226054 C8.18229265,34.4471019 8.61184281,33.119204 8.69780072,31.2401769 C8.7835192,29.3611497 8.51870177,27.8488911 8.2787858,26.5221088 C7.74484108,23.5706666 7.25926263,23.3503264 7.06627633,21.3513672 C6.87879708,19.4154422 7.24250204,18.6721428 7.44075596,16.4812925 C7.58346047,14.9037687 7.39789672,12.8900272 7.02174104,8.92725168",
    id: "Fill-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-121",
    transform: "translate(147.916462, 116.613662) scale(-1, 1) rotate(-180.000000) translate(-147.916462, -116.613662) translate(86.000000, 113.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(77.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.051088,23.6260617 L105.950861,23.6260617 C105.674522,23.6248447 105.406156,23.5355186 105.186599,23.3716765 L74.4597695,0.24804652 C74.0129984,-0.0826821735 73.395385,-0.0826821735 72.9486139,0.24804652 L42.2130997,23.4140741 C41.9935431,23.5779162 41.7251763,23.6672423 41.4488372,23.6684593 L5.68482258,23.6684593 C5.13940001,23.6678737 4.65558874,24.0101744 4.4863199,24.5164106 L0.0570708837,38.4143311 C-0.0615581995,38.784507 0.00700043169,39.1876941 0.241779054,39.5005833 C0.476557677,39.8134725 0.849626962,39.9988424 1.24688876,40 L147.750813,40 C148.138937,39.9995649 148.504856,39.8232117 148.741253,39.5226623 C148.97765,39.2221129 149.057727,38.8314348 148.958001,38.4652083 L145.258275,24.5418492 C145.121565,24.000521 144.622109,23.6216275 144.051088,23.6260617 Z",
    id: "Path",
    fill: "#A3A3A3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,40 L147.757348,40 C148.143441,39.9995688 148.507446,39.8248205 148.742606,39.5270061 C148.977766,39.2291919 149.057425,38.842069 148.958221,38.4791754 L145.277848,24.6825233 C145.141853,24.1461215 144.64501,23.7706759 144.076975,23.77507 L106.176048,23.77507 C105.901155,23.773864 105.634192,23.6853507 105.415784,23.5229996 L74.7847093,0.125443433 C74.5172861,-0.0788279571 74.1343825,-0.0283112406 73.9294701,0.238275672 C73.8536629,0.336899423 73.8099795,0.45630487 73.8042983,0.580423417",
    id: "Path",
    fill: "#8F8F8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7339002,44 L47.2488877,44 C46.9169895,44.0020634 46.5980095,43.8731655 46.3633162,43.6419146 C46.1286229,43.4106637 45.9978063,43.0963622 46,42.769332 L46,31.7893967 C45.9960221,31.4071764 46.176228,31.0457094 46.4857614,30.8153014 L72.2412755,11.2564908 C72.6908307,10.9145031 73.317973,10.9145031 73.7675282,11.2564908 L99.5056984,30.8153014 C99.8174066,31.0448093 100.000682,31.4059832 100,31.7893967 L100,42.769332 C100,43.0986467 99.8660858,43.4142309 99.6281345,43.64548 C99.3901835,43.8767291 99.0680847,44.0043421 98.7339002,44 L98.7339002,44 Z",
    id: "Path",
    fill: "#C9C9C9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9C9C9",
    fillRule: "nonzero",
    x: 2,
    y: 40,
    width: 142,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    fillRule: "nonzero",
    x: 2,
    y: 98,
    width: 142,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    x: 44,
    y: 104,
    width: 60,
    height: 5,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    fillRule: "nonzero",
    x: 47,
    y: 98,
    width: 54,
    height: 5,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 60,
    y: 70,
    width: 28,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE6AA",
    fillRule: "nonzero",
    x: 56,
    y: 70,
    width: 3,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE6AA",
    fillRule: "nonzero",
    x: 89,
    y: 70,
    width: 3,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(65.000000, 23.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFAE5",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-17",
    fill: "#FFDA80",
    cx: 8,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-17-Copy",
    fill: "#FFFCF6",
    cx: 8,
    cy: 8,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(71.000000, 28.000000)",
    stroke: "#FAA918",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2,
    x2: 2,
    y2: 4,
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 0,
    x2: 1,
    y2: 4,
    id: "Line-6-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "school-building-windows",
    transform: "translate(9.000000, 46.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: -2.53663757e-12,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 1,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 19,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 20,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 38,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 39,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: -2.53663757e-12,
    y: 18,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 1,
    y: 19,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 19,
    y: 18,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 20,
    y: 19,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: -2.53663757e-12,
    y: 37,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 1,
    y: 38,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 19,
    y: 37,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 20,
    y: 38,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 94,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 95,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 113,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 114,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 57,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 58,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 75,
    y: 7.10542736e-14,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 76,
    y: 1,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 94,
    y: 18,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 95,
    y: 19,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 113,
    y: 18,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 114,
    y: 19,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 94,
    y: 37,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 95,
    y: 38,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 113,
    y: 37,
    width: 13,
    height: 13,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDEDED",
    x: 114,
    y: 38,
    width: 11,
    height: 11,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2646733,26.2603233 L74.7042912,26 C75.4112693,25.9911001 75.9913359,26.5857148 76,27.3282101 C76,27.3336423 76,27.3390748 76,27.3445073 L76,53.6554947 C76,54.3980444 75.426839,55 74.7198088,55 L54.2801912,55 C53.5731611,55 53,54.3980444 53,53.6554947 L53,27.60473 C53,26.8685368 53.5637474,26.269247 54.2646733,26.2603233 Z",
    id: "Rectangle",
    fill: "#FFFAE5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.8658133,63 L51.9303063,63 C51.7310394,62.9984925 51.5438252,63.0935047 51.4299609,63.2539649 L47.116638,69.035066 C46.9811769,69.2201211 46.9622343,69.4638602 47.0675317,69.6669287 C47.1728291,69.869997 47.3847784,69.9984759 47.6169834,70 L99.3768582,70 C99.6009125,70.0007097 99.8079943,69.882971 99.9187719,69.6918824 C100.029549,69.5007938 100.026851,69.2659766 99.9117102,69.0773873 L96.3489055,63.2962862 C96.2473266,63.1255954 96.0666987,63.0148278 95.8658133,63 L95.8658133,63 Z",
    id: "Path",
    fill: "#FFE6AA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree-copy",
    transform: "translate(298.000000, 44.000000)",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0067891,24.6322766 C19.6371435,25.3230305 19.3104477,25.918932 19.3409283,26.7449939 C19.3669753,27.4581623 19.6642989,28.1593035 20.2301281,28.8992602 C20.9458661,29.834935 21.7815865,30.6784911 22.3984013,31.6896104 C22.9913859,32.6619141 23.1659562,33.6880675 22.8326101,34.7779114 C22.3161039,36.4661171 21.2684054,37.8003352 19.948599,38.9530495 C19.0061968,39.7758311 17.9662569,40.4493639 16.8174184,40.9509599 C16.088657,41.2691385 14.6086893,41.8404388 12.6338288,41.9727399 C11.8457689,42.025223 10.3270078,42.0520111 8.50759796,41.5618957 C6.74360727,41.0862679 5.53131393,40.3498648 5.13562139,40.0983834 C3.7875512,39.2425264 2.8767379,38.2778766 2.31949861,37.5901296 C1.46410445,36.2351368 0.619794098,34.8735837 0.256244648,33.2906175 C-0.128918262,31.6127993 -0.153579772,29.9595823 0.700428923,28.3927438 C1.29701579,27.2982529 2.23636993,26.5834445 3.37855807,26.1018028 C3.81055014,25.9194789 4.21067621,25.6860384 4.5459619,25.3517322 C5.11345373,24.7856258 5.22761712,24.2126855 4.87986213,23.4787424 C4.49774727,22.6720884 3.89478721,22.0141365 3.34419822,21.3225628 C2.38517028,20.1176388 1.44914128,18.8949471 1.17703339,17.3357623 C0.787714042,15.1049582 1.89221718,12.7093244 3.70857894,11.8102784 C4.7745658,11.2824408 5.90954944,11.3726461 7.04231634,11.5489564 C7.57240025,11.6312346 8.09417129,11.7791166 8.63617033,11.7725562 C9.17484421,11.7662692 9.36022117,11.5158812 9.26157513,10.9869501 C9.18648222,10.5845799 9.06068082,10.2029842 8.88417091,9.83314252 C8.2704041,8.5464871 7.94537094,7.19887477 8.03182478,5.76898427 C8.18976928,3.16013802 9.99560143,0.738262716 12.5346286,0.128146951 C13.8771569,-0.194131941 15.1210391,0.132247191 16.3347179,0.653797764 C17.7376529,1.25680645 18.8978523,2.13945152 19.5919769,3.5288863 C19.9275397,4.20023231 20.1550351,4.90000668 20.1522643,5.65855114 C19.9743688,7.18384055 19.5451477,8.28379836 19.1746709,9.01883477 C18.8233137,9.71532895 18.4301149,10.4025292 18.0867935,11.5694576 C17.7642541,12.6661352 17.7997224,13.7505121 19.2910511,14.3188055 C20.1774799,14.6563919 20.904856,15.2451864 21.3498714,16.1125239 C22.3052972,17.7080642 22.3668123,18.9080679 22.2604076,19.6914871 C22.1282331,20.6667975 21.421085,21.9887151 20.0067891,24.6322766",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91692138,53.5407316 C9.59160822,50.4669734 10.3624307,48.0676439 10.9488001,46.429865 C11.1937723,45.7451375 11.7135417,44.7066341 11.8174956,43.2366969 C11.92116,41.7667596 11.6009009,40.5837956 11.3107566,39.545849 C10.6650263,37.2372598 10.0777881,37.0649646 9.84410903,35.5012252 C9.61766907,33.9867528 10.0575186,33.4055695 10.2972785,31.6915242 C10.4695698,30.4576231 10.2454464,28.8824715 9.79053948,25.782549 C9.16073526,21.4938171 8.53932841,19.2854319 9.08776484,16.9331427 C9.34692565,15.8228265 9.79053948,14.728376 9.79053948,14.728376 C10.045936,14.0976474 10.4530646,13.1089677 11.2383653,11.9646936 C12.2637156,10.470262 12.7461311,10.4415925 13.3377128,9.3284929 C13.5036336,9.01563368 14.0859491,7.89112195 13.9892344,6.6558291 C13.769744,3.85512686 10.1753716,1.94178684 10.0801046,2.00135256 C10.0140838,2.04254755 11.5794731,3.05098963 12.2518434,4.96488634 C12.3361069,5.20537597 12.6080085,6.03345083 12.5414085,7.03771774 C12.3963364,9.22049523 10.8109671,9.84955377 9.21140916,12.4737856 C8.89694138,12.989558 7.46330426,15.4170003 7.28087821,18.5826122 C7.21746343,19.6784544 7.32025907,20.5814039 7.47401816,21.9283128 C7.70711812,23.9760934 7.95846068,24.3802496 8.27032236,26.4553076 C8.47880929,27.844525 8.70611794,29.3576056 8.64791535,31.2581418 C8.55583362,34.2625923 7.87217027,34.2623139 8.14957369,36.03676 C8.52513971,38.4399864 9.76505776,38.5159745 10.0801046,40.9823848 C10.2654263,42.4350648 9.96456816,43.6152453 9.59739952,45.054843 C9.19345611,46.6386232 8.79704141,47.2454143 8.2459989,48.7637834 C7.80093725,49.9898908 7.2742182,51.7584918 7,54",
    id: "Fill-25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.279423,128 C186.939017,125.446862 187.557037,121.698562 190.279423,120.262969 C192.304525,119.195028 195.581163,119.359596 198.118799,120.816198 C198.568159,121.264967 200.081324,122.668463 202.03789,122.61244 C204.369917,122.544162 205.969497,120.411781 206.704327,119.434877 C207.959438,117.76527 207.731182,116.842639 209.410622,115.359192 C210.207433,114.655985 210.772411,114.156445 211.695567,114.030393 C213.692659,113.75553 216.13196,115.390705 217.155835,117.086573 C218.003899,118.489486 217.479446,119.266807 218.816204,121.094563 C219.629106,122.207439 220.223287,122.466546 220.702446,122.542995 C221.748372,122.711064 222.086882,121.985097 223.408741,121.921488 C225.000574,121.844456 225.304518,122.858125 227.701506,123.165085 C228.104976,123.21644 228.970919,123.320316 230.034128,123.165085 C231.392937,122.964919 231.814883,122.52432 232.739827,122.314233 C234.475885,121.919737 236.21969,122.735574 236.940216,123.026778 C241.654331,124.929231 256.424399,123.535071 267.201902,123.165085 C272.796859,122.972505 274.729166,122.931655 279.086892,123.165085 C285.047177,123.484884 288.838981,124.797343 292,125.839607 L190.279423,128 Z",
    id: "Fill-47",
    fill: "#EDEDED",
    fillRule: "nonzero",
    transform: "translate(240.000000, 121.000000) scale(-1, 1) translate(-240.000000, -121.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-73-Clipped",
    transform: "translate(255.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#F2F9FB",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "-2.92321722e-12 5 3 5 3 3.50830476e-14 -2.92321722e-12 3.50830476e-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.698641,124.186603 C295.123184,124.190955 294.7584,124.301091 294.703974,123.653043 C294.674323,123.307419 294.347222,123.111034 294.215435,123.35229 C293.980863,123.781284 293.665034,123.832816 293.309773,123.890832 C293.046446,123.934 292.76197,123.98086 292.473687,124.186965 C292.888185,123.354937 293.124891,122.815445 293.030873,122.105431 C292.972097,121.661574 292.964347,121.252458 292.553505,121.116345 C292.095251,120.963681 291.980067,121.46674 291.792661,121.780577 C291.517809,122.242632 291.391186,122.816968 291.435044,123.354333 C291.555275,124.829449 290.974706,125.541099 289.828457,125.733199 C289.773462,125.7428 289.705398,125.652166 289.643859,125.609248 C289.566615,124.728113 290.371332,125.14226 290.585401,124.693619 C290.883156,124.070587 289.772376,122.701121 289.187559,123.009452 C288.199082,123.528813 288.403388,124.625637 288.503221,125.645392 C287.973624,125.683385 287.376763,124.712357 287.064726,125.688683 C286.827833,126.428836 287.264627,127.732167 287.992763,127.884971 C295.473599,128.09442 299.244784,128.01784 299.306318,127.65523 C299.689695,127.33209 299.915668,127.035935 299.984235,126.766764 C300.030123,126.586626 299.975834,126.208817 299.821369,125.633338 C299.908868,125.118693 299.482933,124.982012 299.129089,124.903625 C298.981133,124.872189 298.830175,124.870912 298.675567,124.855855 C298.997009,122.842306 298.886265,122.668219 297.107861,122.470108 C296.916963,122.448572 296.808405,122.391837 296.80601,122.184819 C296.792059,120.583426 295.845396,120.226096 294.796171,120 C294.454877,121.090758 293.263919,121.686715 293.540228,123.349629 C294.867835,121.626959 294.963351,123.463997 295.698641,124.186603 Z",
    id: "Clip-123",
    fill: "#D9D9D9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-126-Clipped",
    transform: "translate(220.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-126",
    fill: "#FEFEFE",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "-1 8 96 8 96 1.36823886e-12 -1 1.36823886e-12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.52879,109.274233 C52.1885213,109.175009 51.8629362,109.045158 51.55809,108.887095 C51.0339125,108.618469 50.75241,108.32614 50.2088187,108.033812 C49.9200238,107.879869 49.6146113,107.747644 49.2963613,107.638773 C48.1393213,107.175405 46.8569987,106.957964 45.5688775,107.006711 C44.3749176,107.085719 44.5981787,107.370147 43.1809576,107.457055 C42.2102587,107.520261 41.6666676,107.393849 40.9774713,107.701979 C40.4824151,107.931101 40.6183126,108.057514 39.9582377,108.492056 C39.2913126,108.827411 38.5972989,109.125687 37.8809413,109.384844 C37.4322089,109.53669 37.0135189,109.741693 36.6384464,109.993203 C36.0906477,110.559633 35.8807739,111.295034 36.0657338,112 L55.2661613,112 C55.5895449,111.907772 55.8479962,111.706057 55.9747713,111.446946 C56.0412624,111.174084 55.9751487,110.890867 55.7903375,110.656868 C55.6270075,110.352864 55.3814649,110.082791 55.0720213,109.866791 C54.3925313,109.44805 53.9071825,109.700875 52.52879,109.274233 Z",
    id: "Path",
    fill: "#F5F5F5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.475947,107.473896 C180.229427,105.549861 180.076721,103.606583 178.864247,101.904792 L178.864247,101.904792 C179.300761,103.895771 179.736684,105.886479 180.172902,107.877187 L180.172902,107.877187 C179.612388,106.584379 179.330356,105.224355 178.761259,103.942117 L178.761259,103.942117 C178.100125,102.452271 176.874629,100.968929 176.089199,100.745872 L176.089199,100.745872 C177.701195,102.856917 178.861584,105.179094 179.681639,107.797776 L179.681639,107.797776 C178.750605,106.503883 177.567725,105.533057 177.020529,104.162735 L177.020529,104.162735 C176.935889,103.951061 176.753589,103.764051 176.58431,103.592219 L176.58431,103.592219 C176.456167,103.462396 176.306716,103.223348 176.079433,103.378377 L176.079433,103.378377 C175.889142,103.507929 176.091863,103.689247 176.159041,103.834248 L176.159041,103.834248 C176.450248,104.46439 177.003956,104.928934 177.424193,105.498095 L177.424193,105.498095 C176.956901,105.334664 176.523938,105.110794 176.008407,105.083691 L176.008407,105.083691 C176.78999,105.647161 177.542866,106.22391 178.238626,106.864894 L178.238626,106.864894 C178.973746,107.540569 179.544322,108.302432 179.886431,109.204688 L179.886431,109.204688 C180.039137,109.58711 180.249255,110.01913 180.435403,109.999345 L180.435403,109.999345 C180.554372,109.986335 180.605274,109.794447 180.694352,109.59253 L180.694352,109.59253 C180.945607,109.02364 181.291563,108.851537 181.662082,108.430087 L181.662082,108.430087 C182.196258,107.822982 182.316706,107.226718 182.456687,106.844296 L182.456687,106.844296 C182.74375,106.06048 183.592808,104.860634 186,103.003273 L186,103.003273 C183.388312,103.801995 182.381813,105.826582 181.451076,107.921365 L181.451076,107.921365 C181.784898,106.471902 182.529488,105.174486 183.221697,103.703612 L183.221697,103.703612 C182.649641,104.076276 182.391875,104.486614 182.072258,104.845186 L182.072258,104.845186 C181.637223,105.026775 181.572412,105.434132 181.413195,105.775899 L181.413195,105.775899 C181.293043,106.033377 181.212547,106.299799 181.152766,106.567846 L181.152766,106.567846 C181.123468,106.879259 181.057473,107.185792 180.999172,107.482569 L180.999172,107.482569 C180.972538,107.667682 180.945015,107.850085 180.91039,108.027338 L180.91039,108.027338 C180.929626,107.850085 180.963068,107.668224 180.999172,107.482569 L180.999172,107.482569 C181.042676,107.181727 181.084404,106.873567 181.152766,106.567846 L181.152766,106.567846 C181.157501,106.515538 181.161349,106.463229 181.164012,106.410649 L181.164012,106.410649 C181.182952,106.022265 180.907726,105.638217 181.104528,105.235197 L181.104528,105.235197 C181.261969,104.409371 181.591944,103.642359 182.029346,102.908954 L182.029346,102.908954 C182.344229,102.38099 182.583646,101.830259 182.534815,101.20093 L182.534815,101.20093 C182.005375,101.823754 181.566197,102.489402 181.134122,103.314685 L181.134122,103.314685 C181.019592,102.074185 180.874581,100.994947 180.319098,100 L180.319098,100 C180.566209,102.492112 180.639603,104.979345 180.475947,107.473896 L180.475947,107.473896 Z",
    id: "Clip-51",
    fill: "#B5B5B5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,115 L302,114.683109 C302.839558,112.218461 304.36053,110.248376 306.26471,109.159117 C310.963684,106.638391 315.467797,111.377356 319.509806,108.921449 C322.96166,106.818443 321.12995,102.439582 324.448184,99.7964201 C328.90219,96.1953826 334.130077,102.43238 343.082627,100.999166 C352.035176,99.5659536 353.337972,92.1694227 359.473365,93.0768842 C365.608755,93.9843457 365.040871,103.620722 373.61483,106.760826 C376.632419,107.862744 378.202455,107.279376 382.144249,109.159117 C385.000757,110.513445 387.657519,112.488792 390,115 Z",
    id: "Path",
    fill: "#D9D9D9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,119 L0,118.740725 C0.973123434,116.724195 2.73606922,115.112307 4.94318613,114.221096 C10.3897254,112.158684 15.6104011,116.036019 20.2954574,114.02664 C24.2964697,112.305999 22.1733519,108.723294 26.0194863,106.560707 C31.1820827,103.614404 37.2416803,108.717401 47.6184993,107.544773 C57.9953183,106.372144 59.5053777,100.320437 66.6168544,101.062905 C73.728331,101.805374 73.0700999,109.689681 83.0080982,112.258858 C86.5057577,113.160427 88.3255723,112.683126 92.8944709,114.221096 C96.2054218,115.329182 99.284852,116.945376 102,119 Z",
    id: "Path",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenEmptyStateIcon);
export default __webpack_public_path__ + "static/media/children-empty-state-icon.3fbd0e6caa3e8a37635b18e5af0f746b.svg";
export { ForwardRef as ReactComponent };